<template>
  <TableLayout :permissions="['business:company:query']">
    <!-- 搜索表单 -->
    <SearchFormCollapse slot="search-form">
      <el-form ref="searchForm" :model="searchForm" label-width="100px" inline>
        <el-form-item label="部门代码" prop="code">
          <el-input v-model="searchForm.code" placeholder="请输入编码" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="企微标识" prop="qwId">
          <el-input v-model="searchForm.qwId" placeholder="请输入企微标识" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="namePath">
          <el-input v-model="searchForm.namePath" placeholder="请输入名称" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <section>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="reset">重置</el-button>
        </section>
      </el-form>
    </SearchFormCollapse>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:company:create', 'business:company:delete']">
        <li><el-button type="primary" @click="$refs.operaCompanyWindow.open('新建组织信息表')" icon="el-icon-plus" v-permissions="['business:company:create']">新建</el-button></li>
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['business:company:delete']">删除</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="名称" min-width="100px"></el-table-column>
        <el-table-column prop="code" label="部门代码" min-width="100px"></el-table-column>
        <el-table-column prop="qwId" label="企微标识" min-width="100px"></el-table-column>
        <el-table-column prop="namePath" label="名称路径" min-width="100px"></el-table-column>
        <el-table-column prop="idPath" label="编码路径" min-width="100px"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" min-width="100px"></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="100px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['business:company:update', 'business:company:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaCompanyWindow.open('编辑组织信息表', row)" icon="el-icon-edit" v-permissions="['business:company:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:company:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaCompanyWindow ref="operaCompanyWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import SearchFormCollapse from '@/components/common/SearchFormCollapse'
import Pagination from '@/components/common/Pagination'
import OperaCompanyWindow from '@/components/business/OperaCompanyWindow'
export default {
  name: 'Company',
  extends: BaseTable,
  components: { SearchFormCollapse, TableLayout, Pagination, OperaCompanyWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        id: '',
        creator: '',
        createDate: '',
        editor: '',
        editDate: '',
        isdeleted: '',
        name: '',
        remark: '',
        status: '',
        sortnum: '',
        imgurl: '',
        type: '',
        parentId: '',
        code: '',
        qwId: '',
        namePath: '',
        idPath: ''
      }
    }
  },
  created () {
    this.config({
      module: '组织信息表',
      api: '/business/company',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
